import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Dialog, Paper } from "@material-ui/core";
import { getChecklistTemplateById } from "./services/checklistTemplatesApisService";
import { checklistTranslationsFullMapper } from "./mappers/checklistTranslationsFullMapper";
import TranslationsTable from "../../../Translations/TranslationsTable";
import DelayedRedirect from "../../../../utils/DelayedRedirect";
import AppBarComponent from "../../../Common/Headers/AppBarComponent";
import { languages, syncTranslationKeys } from "./utils/constants";
import { baseUrl } from "./services/checklistTemplatesApisService";

export default function ChecklistTemplatesTranslations({
  templateId,
  resources,
  hasTranslationLicence
}) {
  const [loading, setLoading] = useState(false);
  const [translationData, setTranslationData] = useState([]);
  const [selectedTemplateId] = useState(templateId);
  const [dialogOpen, setDialogOpen] = useState(true);
  const [redirect, setRedirect] = useState(null);
  const [refreshAfterSave, setRefreshAfterSave] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      const templateRaw = await getChecklistTemplateById(selectedTemplateId);
      if (!templateRaw) {
        setLoading(false);
        setRedirect(`/checklisttemplates/${templateId}`);
        return;
      }

      const mapped = checklistTranslationsFullMapper(templateRaw);
      setTranslationData(mapped);
      setLoading(false);
    }

    fetchData();
  }, [selectedTemplateId, templateId]);

  const syncTranslation = () => {
    setRefreshAfterSave(true);
  };

  const deleteTranslation = () => {
    setRefreshAfterSave(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
    setRedirect(`/checklisttemplates/${templateId}`);
  };

  return (
    <Box>
      {redirect && (
        <DelayedRedirect
          to={{
            pathname: redirect,
            state: { refreshTemplate: refreshAfterSave },
          }}
          delay={250}
        />
      )}
      <Dialog fullScreen open={dialogOpen} onClose={handleClose}>
        <AppBarComponent
          idName="addTranslations"
          title={resources["ChecklistTemplateTranslations"]}
          resources={resources}
          handleClose={handleClose}
          hasBackIcon
          hasSaveButton={false}
        />
        {loading ? (
          <Box className="centered-loader fadeIn">
            <CircularProgress />
          </Box>
        ) : (
          <div className="container py-4">
            <Paper elevation={3} className="p-4 mt-3">
              <Box
                className="mb-3"
                style={{ maxWidth: "900px", margin: "auto" }}
              >
                <TranslationsTable
                  data={translationData}
                  languages={languages}
                  defaultLang="nl"
                  onTranslationSync={syncTranslation}
                  onDeleteTranslation={deleteTranslation}
                  resources={resources}
                  baseUrl={baseUrl}
                  syncTranslationKeys={syncTranslationKeys}
                  hasTranslationLicence={hasTranslationLicence}
                />
              </Box>
            </Paper>
          </div>
        )}
      </Dialog>
    </Box>
  );
}
